const LastConnectedWalletKey = 'ktn_last_connected_wallet';

export enum WalletsType {
  MultiversX = 'multiversX',
  MetaMask = 'metaMask',
  WalletConnect = 'walletConnect',
  Ledger = 'ledger',
  Coinbase = 'coinbaseWallet',
  UnstoppableDomains = 'unstoppableDomains',
  TronLink = 'tronLink',
  TON = 'ton',
  TREZOR = 'trezor',
  Other = 'injected',
}

export enum WalletsName {
  MultiversX = 'MultiversX Wallet',
  MetaMask = 'MetaMask',
  WalletConnect = 'WalletConnect',
  Ledger = 'Ledger',
  Coinbase = 'Coinbase Wallet',
  UnstoppableDomains = 'UnstoppableDomains',
  TronLink = 'TronLink Wallet',
  TON = 'TON Wallet',
  TREZOR = 'TREZOR Wallet',
  Brave = 'Brave Wallet',
  BlockWallet = 'BlockWallet',
}

export const SetLastConnectedWallet = (wallet: WalletsType) => {
  localStorage.setItem(LastConnectedWalletKey, wallet);
};

export const GetLastConnectedWallet = (): WalletsType => {
  const res = localStorage.getItem(LastConnectedWalletKey);

  if (res) {
    return res as WalletsType;
  }
  return WalletsType.MetaMask;
};
